import React from 'react'
import Field from '../Field'
import classNames from 'classnames'
import ReactPhoneInput from 'react-phone-input-2'
import './react-datetime-overrides.css'

const PhoneInputElement = ({ innerRef, errors, className, ...props }) => (
  <ReactPhoneInput
    containerClass={classNames(className, [
      'w-full',
      'transition',
      'duration-200',
      'border',
      'peer',
    ], {
      xs:   'p-1',
      sm:   'p-1 sm:p-2',
      base: 'p-1 sm:p-2 md:p-4',
      lg:   'p-1 sm:p-2 md:p-4 lg:p-6',
    }[props.size] ?? '', {
      'border-gray-300 focus:border-primary': !errors.length,
      'border-negative': !!errors.length,
    })}

    ref={innerRef}
    {...props}
  />
)

export const PhoneInput = (props) => (
  <Field {...props} element={PhoneInputElement} />
)

export default PhoneInput
